//Subscribers from below countries can subscribe to new subscriptions
export const subscriberCountriesConfigured = [
  'AUS',
  'IND',
  'IRL',
  'USA',
  'GBR',
];

export const noSubscriptions = 'noSubscriptions';

export const paymentMethodSaveButtonId = 'PaymentFormSaveButton';
